import DOMPurify from 'dompurify'
import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'

import type {updateLabelMutation, updateLabelMutation$data} from './__generated__/updateLabelMutation.graphql'

export function commitUpdateLabelMutation({
  environment,
  input,
  onError,
  onCompleted,
}: {
  environment: Environment
  input: {
    id: string
    name: string
    description?: string
    color: string
  }
  onError?: (error: Error) => void
  onCompleted?: (response: updateLabelMutation$data) => void
}) {
  return commitMutation<updateLabelMutation>(environment, {
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    mutation: graphql`
      mutation updateLabelMutation($input: UpdateLabelInput!) @raw_response_type {
        updateLabel(input: $input) {
          label {
            id
            name
            nameHTML
            description
            color
          }
        }
      }
    `,
    variables: {input},
    optimisticResponse: {
      updateLabel: {
        label: {
          id: input.id,
          name: input.name,
          nameHTML: DOMPurify.sanitize(input.name, {ALLOWED_TAGS: [], ALLOWED_ATTR: [], ALLOW_ARIA_ATTR: false}),
          description: input.description ?? null,
          color: input.color,
        },
      },
    },
    onError: error => onError?.(error),
    onCompleted: response => onCompleted?.(response),
  })
}
